<template>
  <screen
    class="scan-container"
    :can-leave="true"
    :can-skip="false"
    :screen-info="info"
    @leave="leaveScan"
  >
    <force-scan v-show="canForceScan" @click="startScan" />
    <doll
      :left="left"
      :right="right"
      :left-range="leftRange"
      :right-range="rightRange"
      :left-breathing="breathing"
      :right-breathing="breathing"
      @left-hit="handleLeftHit"
      @right-hit="handleRightHit"
    />
  </screen>
</template>

<script>
import { mapGetters } from 'vuex';
import i18n from '@/i18n';
import autoClearTimer from '@/mixins/auto-clear-timer';
import handleArmDetection from '@/mixins/arm-detection';
import leave from '@/mixins/leave';
import audioPlayer from '@/mixins/audio-player';
import brandMode from '@/mixins/brand-mode';
import ENVS from '@/modules/envs';
import ScanProcess from '@/modules/scan-process';

import Screen from '../components/common/Screen.vue';
import ForceScan from '../components/common/ForceScan.vue';
import Doll from '../components/common/Doll.vue';

export default {
  name: 'ChooseToStart',
  components: {
    Screen,
    ForceScan,
    Doll,
  },
  mixins: [autoClearTimer, handleArmDetection, leave, audioPlayer, brandMode],
  mounted() {
    this.startArmDetection();
    if (ScanProcess.twoStepScan()) {
      this.toggleArmMotionListening(false);
      this.info = i18n.t('scan.two_step_scan');
      this.playAndWait('two_phase_scan', 1).then(() => {
        if (this.redirecting) return;
        this.toggleArmMotionListening(true);
        this.info = this.stepInfoText;
        this.playAudio('8-Start_3D_body_scan');
      });
    } else {
      this.info = this.stepInfoText;
      this.playAudio('8-Start_3D_body_scan');
    }
  },
  data: () => ({
    info: i18n.t('choose.clench_fingers'),
    breathing: true,
    activeTime: 500,
    redirecting: false,
  }),
  methods: {
    startScan() {
      if (this.redirecting) return;

      this.redirecting = true;
      this.stopAudio();
      this.$events.goto('ScanBody');
    },
    leaveScan() {
      console.log('user leave');
      ScanProcess.reportEvent('user_leave');
      this.leave();
    },
  },
  computed: {
    ...mapGetters('app', ['isWeb']),
    stepInfoText() {
      if (this.isSanne) return i18n.t('sanne.step_info');
      return i18n.t('choose.step_info');
    },
    bothReady() {
      return this.leftReady && this.rightReady;
    },
    canForceScan() {
      return this.isWeb || ENVS.mock;
    },
  },
  watch: {
    bothReady(nv) {
      if (nv) {
        this.startScan();
      }
    },
  },
};
</script>
